import { getCustomFormConfig } from '../../dateneingabe/co2_custom/getCustomFormConfig';
import { IDs } from '../../../helpers/IDs';
import { isValid } from '../../../main/functions/validData';
import * as React from 'react';
import { ReportTextButton } from './ReportTextButton';
import { StructureService } from '../../../services/structure_service';

const ENTITIES: any = {
    [IDs.ENT_VSME_B1]: {
        id: 'b1', name: 'B1', titel: 'Einordnung Unternehmen', column: 'Größenordnung',
        fields: [
            { name: 'Anzahl Beschäftigte', key: 'anzahl_beschaeftigte' },
            { name: 'Bilanzsumme', key: 'bilanzsumme' },
            { name: 'Nettoumsatzerlöse', key: 'nettoumsatzerloese' },
            {
                name: 'Einordnung', key: 'unternehmenseinordnung_name', classes: [, 'row_field_vsme_bold_left', 'row_field_vsme_bold_right']
            },
            {
                name: 'Berichtsform', key: 'bericht', classes: [, 'row_field_vsme_bold_left', 'row_field_vsme_bold_right'],
                procValues: (value: any) => typeof value === 'string' ? (value.match(/\((.*?)\)/) || [])[1] || value : value
            }
        ]
    },
    [IDs.ENT_VSME_B3]: {
        id: 'b3', name: 'B3', titel: 'Energie & Emissionen', column: 'Menge',
        fields: [
            /*{ name: '... unvollständig implementiert...', classes: [, 'row_field_vsme_span', 'row_field_vsme_none'] },*/
            {
                name: 'Stromverbrauch konventionell [MWh]', key: 'strom', forced: true,
                procValues: (value: any) => isNumber(value) ? `${formatFloat.format(value / 1000)} MWh` : value
            },
            {
                name: 'Stromverbrauch regenerativ [MWh]', key: 'stromverbrauch_regenerativ', forced: true,
                procValues: (value: any) => isNumber(value) ? `${formatFloat.format(value / 1000)} MWh` : value
            },
            {
                name: 'Nutzung fossiler Brennstoffe [MWh]', key: 'fossile_brennstoffe', forced: true,
                procValues: (value: any) => isNumber(value) ? `${formatFloat.format(value / 1000)} MWh` : value
            },
            {
                name: 'Energieverbrauch gesamt [MWh]', key: 'energieverbrauch_gesamt', forced: true,
                classes: [, 'row_field_vsme_bold_left', 'row_field_vsme_bold_right'],
                procValues: (value: any) => isNumber(value) ? `${formatFloat.format(value / 1000)} MWh` : value
            },
            {
                name: 'Emissionen nach Scope 1 [t CO₂ Äq]', key: 'scope1', forced: true,
                procValues: (value: any) => isNumber(value) ? `${formatFloat.format(value)} t CO₂ Äq` : value
            },
            {
                name: 'Emissionen nach Scope 2 [t CO₂ Äq]', key: 'scope2', forced: true,
                procValues: (value: any) => isNumber(value) ? `${formatFloat.format(value)} t CO₂ Äq` : value
            },
            {
                name: 'CO2 Fußabdruck (Scope 1 + 2) [t CO₂ Äq]', key: 'emissionen_gesamt', forced: true,
                classes: [, 'row_field_vsme_bold_left', 'row_field_vsme_bold_right'],
                procValues: (value: any) => isNumber(value) ? `${formatFloat.format(value)} t CO₂ Äq` : value
            }
        ]
    },
    [IDs.ENT_VSME_B4]: {
        id: 'b4', name: 'B4', titel: 'Verschmutzung / Schadstoffe', column: 'Menge',
        fields: [
            {
                key: 'tid',
                fields: [
                    {
                        name: 'Schadstoff', key: 'name',
                        classes: ['row_field_vsme_bold_right', 'row_field_vsme_bold_left', 'row_field_vsme_bold_right'],
                        procSub: (index: number) => typeof index === 'number' ? `${index + 1}.` : ''
                    },
                    {
                        name: 'Gefährdung', key: 'kategorien', classes: [, 'row_field_vsme_indent_left',],
                        procValues: (values: string[]) => Array.isArray(values) ? values.join(' / ') : values,
                    },
                    {
                        name: 'Menge', key: 'menge', classes: [, 'row_field_vsme_indent_left',],
                        procValues: (value: any, unit: string) =>
                            isNumber(value) ? `${formatFloat.format(value)}${unit ? ` ${unit}` : ''}` : value
                    }
                ]
            }
        ]
    },
    [IDs.ENT_VSME_B5]: {
        id: 'b5', name: 'B5', titel: 'Biologische Vielfalt am Standort', column: 'Größe [Einheit]',
        fields: [
            {
                name: 'Fläche des Standorts - Gesamtgröße', key: 'jahr_flaeche_nutzung',
                procValues: (value: any, unit: string) =>
                    isNumber(value) ? `${formatFloat.format(value)}${unit ? ` ${unit}` : ''}` : value
            },
            {
                name: 'Veränderung ggü. Vorjahr',
                keys: ['vorjahr_flaeche_nutzung_veraenderung_prozent', 'vorjahr_flaeche_nutzung_veraenderung'],
                classes: [, 'row_field_vsme_indent_left', 'row_field_vsme_cols_2_right'],
                procValues: (value: any, unit: string, key: string) => {
                    unit = key === 'vorjahr_flaeche_nutzung_veraenderung_prozent' ? '%' : (unit ? ` ${unit}` : '');
                    return isNumber(value) ? `${formatFloat.format(value)}${unit}` : value;
                }
            },
            {
                name: 'Versiegelte Fläche', key: 'jahr_flaeche_versiegelt',
                procValues: (value: any, unit: string) =>
                    isNumber(value) ? `${formatFloat.format(value)}${unit ? ` ${unit}` : ''}` : value
            },
            {
                name: 'Veränderung ggü. Vorjahr',
                keys: ['vorjahr_flaeche_versiegelt_veraenderung_prozent', 'vorjahr_flaeche_versiegelt_veraenderung'],
                classes: [, 'row_field_vsme_indent_left', 'row_field_vsme_cols_2_right'],
                procValues: (value: any, unit: string, key: string) => {
                    unit = key === 'vorjahr_flaeche_versiegelt_veraenderung_prozent' ? '%' : (unit ? ` ${unit}` : '');
                    return isNumber(value) ? `${formatFloat.format(value)}${unit}` : value;
                }
            },
            {
                name: 'Naturnahe Fläche', key: 'jahr_flaeche_naturnah_standort',
                procValues: (value: any, unit: string) =>
                    isNumber(value) ? `${formatFloat.format(value)}${unit ? ` ${unit}` : ''}` : value
            },
            {
                name: 'Veränderung ggü. Vorjahr',
                keys: ['vorjahr_flaeche_naturnah_standort_veraenderung_prozent', 'vorjahr_flaeche_naturnah_standort_veraenderung'],
                classes: [, 'row_field_vsme_indent_left', 'row_field_vsme_cols_2_right'],
                procValues: (value: any, unit: string, key: string) => {
                    unit = key === 'vorjahr_flaeche_naturnah_standort_veraenderung_prozent' ? '%' : (unit ? ` ${unit}` : '');
                    return isNumber(value) ? `${formatFloat.format(value)}${unit}` : value;
                }
            },
            {
                name: 'Naturnahe Fläche außerhalb Standort', key: 'jahr_flaeche_naturnah_ausserhalb',
                procValues: (value: any, unit: string) =>
                    isNumber(value) ? `${formatFloat.format(value)}${unit ? ` ${unit}` : ''}` : value
            },
            {
                name: 'Veränderung ggü. Vorjahr',
                keys: ['vorjahr_flaeche_naturnah_ausserhalb_veraenderung_prozent', 'vorjahr_flaeche_naturnah_ausserhalb_veraenderung'],
                classes: [, 'row_field_vsme_indent_left', 'row_field_vsme_cols_2_right'],
                procValues: (value: any, unit: string, key: string) => {
                    unit = key === 'vorjahr_flaeche_naturnah_ausserhalb_veraenderung_prozent' ? '%' : (unit ? ` ${unit}` : '');
                    return isNumber(value) ? `${formatFloat.format(value)}${unit}` : value;
                }
            },
            {
                name: 'Anteil in/nahe Schutzgebiet', key: 'grundstuecksflaeche',
                procValues: (value: any, unit: string) =>
                    isNumber(value) ? `${formatFloat.format(value)}${unit ? ` ${unit}` : ''}` : value
            }
        ]
    },
    [IDs.ENT_VSME_B6]: {
        id: 'b6', name: 'B6', titel: 'Wasser', column: 'Menge [Einheit]',
        fields: [
            {
                name: 'Bezugsmenge vom Versorger', key: 'fremdbezug', entity: IDs.ENT_ENERGIEDATEN_WASSER,
                procValues: (value: any) => isNumber(value) ? `${formatFloat.format(value)} m³` : value
            },
            {
                name: 'Bezugsmenge Regen-/Brunnennutzung', key: 'regen_brunnennutzung', entity: IDs.ENT_ENERGIEDATEN_WASSER,
                procValues: (value: any) => isNumber(value) ? `${formatFloat.format(value)} m³` : value
            },
            // {
            //     name: 'Abwassermenge', key: 'abwassermenge', entity: IDs.ENT_ENERGIEDATEN_WASSER,
            //     procValues: (value: any) => isNumber(value) ? `${formatFloat.format(value)} m³` : value
            // },
            {
                name: 'gesamter Wasserbezug', key: 'bezug_gesamt', entity: IDs.ENT_ENERGIEDATEN_WASSER,
                procValues: (value: any) => isNumber(value) ? `${formatFloat.format(value)} m³` : value
            },
            { name: 'Wasserrisiko am betrachteten Standort', key: 'modus' }
        ]
    },
    [IDs.ENT_VSME_B7]: {
        id: 'b7', name: 'B7', titel: 'Ressourcen / Abfall', column: 'Menge [Einheit]',
        fields: [
            {
                group: 'kategorie', entity: IDs.ENT_CO2_SCOPE3_ABFALL,
                fields: [
                    {
                        name: 'Abfallart', key: 'menge',
                        classes: ['row_field_vsme_right', ,],
                        procSub: (index: number) => typeof index === 'number' ? `${index + 1}.` : '',
                        procName: (item: any) => (item || {}).name ? `Abfallart [${item.name}]` : 'Abfallart',
                        procValues: (value: any, unit: string) =>
                            isNumber(value) ? `${formatFloat.format(value)}${unit ? ` ${unit}` : ''}` : value
                    }
                ]
            },
            {
                name: 'Recyclinganteil in %', key: 'recycling_anteil',
                procValues: (value: any) => isNumber(value) ? `${formatFloat.format(value)}%` : value
            },
            {
                name: 'Stofflich verwertbarer Anteil (Prod./Vpck.)', key: 'verwertbare_stoffe_anteil',
                procValues: (value: any) => isNumber(value) ? `${formatFloat.format(value)}%` : value
            }
        ]
    },
    [IDs.ENT_VSME_B8]: {
        id: 'b8', name: 'B8', titel: 'Arbeitskräfte - Allgemein', column: 'Anzahl',
        fields: [
            { name: 'Mitarbeitende am Standort (gesamt)', key: 'anz_mitarbeiter_real', entity: IDs.ENT_BETRIEBSDATEN },
            { name: 'weiblich', key: 'geschlecht_weiblich', classes: [, 'row_field_vsme_indent_left',] },
            { name: 'männlich', key: 'geschlecht_maennlich', classes: [, 'row_field_vsme_indent_left',] },
            { name: 'divers', key: 'geschlecht_diverse', classes: [, 'row_field_vsme_indent_left',] },
            { name: 'unbefristet', key: 'arbeitsvertraege_unbefristet', classes: [, 'row_field_vsme_indent_left',] },
            { name: 'befristet', key: 'arbeitsvertraege_befristet', classes: [, 'row_field_vsme_indent_left',] },
            { name: 'Mitarbeitende am Standort (VZ-Äquivalent)', key: 'anz_mitarbeiter', entity: IDs.ENT_BETRIEBSDATEN },
            { name: 'Auszubildende am Standort', key: 'anz_auzubildende', entity: IDs.ENT_BETRIEBSDATEN },
            { name: 'Praktikanten am Standort', key: 'anz_praktikanten', entity: IDs.ENT_BETRIEBSDATEN }
        ]
    },
    [IDs.ENT_VSME_B9]: {
        id: 'b9', name: 'B9', titel: 'Arbeitskräfte - Gesundheit', column: 'Anzahl',
        fields: [
            { name: 'Arbeitsunfälle', key: 'arbeitsunfaelle_anzahl' },
            {
                name: 'Quote meldepflichtige Arbeitsunfälle', key: 'arbeitsunfaelle_quote',
                classes: [, 'row_field_vsme_bold_left', 'row_field_vsme_bold_right'],
                procValues: (value: any) => isNumber(value) ? formatFloat.format(value) : value
            },
            { name: 'Todesfälle nach Verletzungen ', key: 'todesfaelle_verletzungen' },
            { name: 'Todesfälle nach Erkrankungen', key: 'todesfaelle_erkrankungen' }
        ]
    },
    [IDs.ENT_VSME_B10]: {
        id: 'b10', name: 'B10', titel: 'Arbeitskräfte - Entlohnung / Bildung', column: 'Lohn / Tarifvertrag',
        fields: [
            {
                name: 'Branchenüblicher Mindestlohn', key: 'mindestlohn',
                procValues: (value: any, unit: string) =>
                    isNumber(value) ? `${formatFloat.format(value)}${unit ? ` € / ${unit}` : ''}` : value
            },
            {
                name: 'Einstiegslohn für neue Mitarbeiter', key: 'einstiegslohn',
                procValues: (value: any, unit: string) =>
                    isNumber(value) ? `${formatFloat.format(value)}${unit ? ` € / ${unit}` : ''}` : value
            },
            { name: 'Anzahl MA unter Tarifvertrag', key: 'mitarbeiter_tarifvertrag' },
            {
                name: 'Bruttostundenlohn weibliche MA', key: 'lohn_weiblich',
                procValues: (value: any) => isNumber(value) ? `${formatFloat.format(value)} € / h` : value
            },
            {
                name: 'Bruttostundenlohn männliche MA', key: 'lohn_maennlich',
                procValues: (value: any) => isNumber(value) ? `${formatFloat.format(value)} € / h` : value
            },
            {
                name: 'Bruttostundenlohn diverse MA', key: 'lohn_divers',
                procValues: (value: any) => isNumber(value) ? `${formatFloat.format(value)} € / h` : value
            },
            {
                name: 'Lohngefälle zwischen weibl. & männl. MA', key: 'lohngefaelle',
                classes: [, 'row_field_vsme_bold_left', 'row_field_vsme_bold_right'],
                procValues: (value: any) => isNumber(value) ? `${formatFloat.format(value)}%` : value
            },
            {
                name: 'Aus-, Fort- & Weiterbildung - weibliche MA', key: 'bildung_weiblich',
                procValues: (value: any) => isNumber(value) ? `${formatFloat.format(value)} h` : value
            },
            {
                name: 'Aus-, Fort- & Weiterbildung - männliche MA', key: 'bildung_maennlich',
                procValues: (value: any) => isNumber(value) ? `${formatFloat.format(value)} h` : value
            },
            {
                name: 'Aus-, Fort- & Weiterbildung - diverse MA', key: 'bildung_divers',
                procValues: (value: any) => isNumber(value) ? `${formatFloat.format(value)} h` : value
            }
        ],
    },
    [IDs.ENT_VSME_B12]: {
        id: 'b12', name: 'B12', titel: 'Verurteilung & Geldstrafen', column: 'Anzahl / Kosten',
        fields: [
            { name: 'Anzahl Verurteilungen', key: 'verurteilungen' },
            {
                name: 'Gesamthöhe Geldbußen [€]', key: 'geldbussen',
                procValues: (value: any) => isNumber(value) ? `${formatFloat.format(value)} €` : value
            }
        ]
    }
};
const formatFloat: any = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2, useGrouping: true });
const GROUPS: any = {};
const STRUCTURES: any = {};
let CACHE: any;
let DATA: any;
let DOC_TYPE: string;
let END: number;
let STANDORT: number;
let START: number;

export function getConfig(dataGlobal: any, jahrVon: number, jahrBis: number, standortTid: number, docType?: 'docx' | 'pdf'): any {
    CACHE = {};
    DATA = dataGlobal || {};
    DOC_TYPE = docType || null;
    END = jahrBis || 0;
    STANDORT = standortTid || 0;
    START = jahrVon || 0;
    const configColumns: any = getConfigColumns() || {};
    const configEntities: any = getConfigEntities() || {};

    return {
        custom_row_classes: [...(configColumns.classes || []), ...(configEntities.classes || [])],
        rows: [...(configColumns.rows || []), ...(configEntities.rows || [])]
    };
}

function getConfigColumns(): any {
    const config: any = {
        classes: [['row_field_vsme_heading2', 'row_field_vsme_heading_left']],
        rows: [['Basis-\nmodul', 'Berichtskriterium']]
    };

    for (let jahr: number = START; jahr <= END; ++jahr) {
        config.classes[0].push('row_field_vsme_heading');
        config.rows[0].push(jahr);
    }

    return config;
}

function getConfigEntities(): any {
    const config: any = { classes: [], rows: [] };

    Object.keys(ENTITIES).forEach((key: string) => {
        const entity: any = ENTITIES[key] || {};
        config.classes.push(['row_field_vsme_sub_left', 'row_field_vsme_sub_left']);
        config.rows.push([entity.name, entity.titel.toUpperCase()]);
        setConfigEntityColumns(key, config);
        setConfigEntityData(key, config);
    });

    return config;
}

function getMaxItems(entity: string, field: any): number {
    const isGroup: boolean = typeof field.group === 'string' && field.group.trim();
    const values: number[] = [];
    let index: number = 0;

    if (isGroup) {
        GROUPS[entity] = [];
    }

    for (let jahr: number = START; jahr <= END; ++jahr) {
        const items: any[] = (DATA[entity] || [])
            .filter((item: any) => {
                if ((item.standort_tid_orig || item.standort_tid) === STANDORT && item.jahr === jahr && isValid(item, entity, DATA)) {
                    if (isGroup && GROUPS[entity].indexOf(item[field.group]) === -1) {
                        GROUPS[entity].push(item[field.group]);
                    }
                    return true;
                }
                return false;
            });
        values.push(items.length);
        ++index;
    }

    return isGroup ? GROUPS[entity].length : Math.max(...values);
}

function getStructure(entity: string): any {
    return (((StructureService || {}).structures || {})[IDs.MOD_ETOOL] || {})[entity] || {};
}

function getUnit(key: string, item: any, structure: any): string {
    const entity: string = (structure.SRC || {}).id || null;
    // console.info('getUnit', key, entity, item, structure);
    switch (entity) {
        case IDs.ENT_CO2_SCOPE3_ABFALL:
            if (typeof item.co2_absolut !== 'undefined') {
                return 'kg'
            } else if (typeof item.menge !== 'undefined') {
                return 'kg'
            } else if (typeof item.volumen_tonne !== 'undefined') {
                return 'Liter'
            }
            return null;
        case IDs.ENT_ENERGIEDATEN_WASSER:
            return ['abwassermenge', 'fremdbezug', 'wasser_bezugsmenge'].indexOf(key) !== -1
                ? item.einheit_tid
                : (key === 'regen_brunnennutzung' ? item.einheit_regen_tid : null)
        case IDs.ENT_VSME_B4:
            return transformValue('einheit', item, structure);
        case IDs.ENT_VSME_B5:
            return transformValue('einheit', item, structure);
        case IDs.ENT_VSME_B10:
            return ({ stunde: 'h', tag: 'd', monat: 'M', jahr: 'J' } as any)[item.einheit];
        default:
            return null;
    }
}

function getValue(key: string, item: any, jahr: number, entity: string, structure: any, position: number[]): any {
    const curEntity: any = ENTITIES[entity] || {};
    const group: any = (curEntity.fields || [])[position[0]] || {};
    const groupKey: string = group.key || group.group || null;
    const groupValue: any = item[groupKey] || null;
    const fields: any[] = Object.keys(group).length ? group.fields || [] : curEntity.fields || [];
    const forced: boolean = !!(fields.find((field: any) => field.key === key) || {}).forced;
    const id: string = curEntity.id || null;
    const kennzahlen: any = (((DATA[IDs.KENNZIFFERN_BERECHNET] || {})[jahr] || {}).vsme || {})[STANDORT] || {};
    const value: any = /*kennzahlen.available && */(Object.keys(item).length || forced)
        ? (groupKey ? ((kennzahlen[id] || {})[groupValue] || {})[key] : (kennzahlen[id] || {})[key])
        : undefined;
    // console.info('getValue', key, id, entity, item, value, structure, jahr, position, kennzahlen, ENTITIES[entity], groupKey, groupValue);
    if (typeof value !== 'undefined') {
        return value;
    }

    return transformValue(key, item, structure);
}

function isNumber(value: number): boolean {
    return typeof value === 'number' && !isNaN(value);
}

function renderReportTextButton(key: string): JSX.Element {
    return (
        <div style={{ marginTop: -8, position: 'relative' }}>
            <ReportTextButton
                data={DATA}
                standort={STANDORT}
                keyData={key}
                styleProps={{ color: 'white', backgroundColor: '#ed7d31' }}
            />
        </div>
    );
}

function setConfigEntityColumns(entity: string, config: any): void {
    const column: string = (ENTITIES[entity] || {}).column || '';
    const index: number = config.rows.length - 1;

    for (let jahr: number = START; jahr <= END; ++jahr) {
        config.classes[index].push('row_field_vsme_sub');
        config.rows[index].push(column);
    }

    if (DOC_TYPE !== 'docx') {
        // config.classes[index].push('row_field_vsme_jsx_none');
        // config.rows[index].push(renderReportTextButton(entity));
    }
}

function setConfigEntityData(key: string, config: any): void {
    ((ENTITIES[key] || {}).fields || []).forEach((item: any, fieldIndex: number) => {
        if (Array.isArray(item.fields)) {
            const entity: string = item.entity || key;

            for (let dataIndex: number = 0, max: number = getMaxItems(entity, item); dataIndex < max; ++dataIndex) {
                item.fields.forEach((group: any) => {
                    setConfigEntityValues(config, group, key, [fieldIndex, dataIndex]);
                });
            }
        } else {
            setConfigEntityValues(config, item, key);
        }
    });
    // setConfigEntityText(config, key);
}

function setConfigEntityText(config: any, entity: string): void {
    const text: string = ((DATA[IDs.ENT_VSME_REPORT] || []).find((item: any) =>
        (item.standort_tid_orig || item.standort_tid) === STANDORT && item.key_group === entity) || {}).text;

    if (typeof text !== 'string' || !text.trim().length) {
        return;
    }
    config.classes.push(['row_field_vsme_nobg_span', 'row_field_vsme_none']);
    config.rows.push([text, '.']);
}

function setConfigEntityValues(config: any, field: any, entity: string, position: number[] = []): void {
    const classes: string[] = field.classes || [];
    const id: string = field.entity || (((ENTITIES[entity] || {}).fields || [])[position[0]] || {}).entity || entity;
    const groupKey: string = (((ENTITIES[entity] || {}).fields || [])[position[0]] || {}).group || null;
    const groupValue: any = (GROUPS[id] || {})[position[1]] || null;
    const keys: string[] = Array.isArray(field.keys) ? field.keys : [field.key || null];
    const procName = field.procName;
    const procSub = field.procSub;
    const procValues = field.procValues;
    config.classes.push([classes[0] || 'row_field_vsme_left', classes[1] || 'row_field_vsme_left']);
    config.rows.push([]);
    const index: number = config.rows.length - 1;

    if (!STRUCTURES[id]) {
        STRUCTURES[id] = getStructure(id) || {};
    }
    const structure: any = STRUCTURES[id];

    for (let jahr: number = START; jahr <= END; ++jahr) {
        const classes: string[] = field.classes || [];
        const items: any[] = [];

        (DATA[id] || []).forEach((item: any) => {
            if (
                (item.standort_tid_orig || item.standort_tid) === STANDORT && item.jahr === jahr
                && (!groupKey || groupValue === item[groupKey]) && isValid(item, entity, DATA)
            ) {
                items.push(transformItem(item, id, { jahr, standort_tid: STANDORT }));
            }
        });
        const item: any = items[groupKey ? 0 : position[1] || 0] || {};

        // keys.forEach((key: string) => {
        //     const unit: string = getUnit(key, item, structure);
        //     const value: any = getValue(key, item, jahr, entity, structure, position);
        //     if (!config.rows[index].length) {
        //         config.rows[index].push(typeof procSub === 'function' ? procSub(position[1] || 0) : '');
        //         config.rows[index].push(typeof procName === 'function'
        //             ? procName(
        //                 { value: groupValue, name: transformValue(groupKey, { [groupKey]: groupValue }, structure) },
        //                 position[1] || 0
        //             )
        //             : field.name
        //         );
        //     }
        //     config.classes[index].push(classes[2] || 'row_field_vsme_right');
        //     config.rows[index].push(typeof procValues === 'function' ? procValues(value, unit, key) : value);
        // });

        if (!keys.length) {
            return;
        }
        if (!config.rows[index].length) {
            config.rows[index].push(typeof procSub === 'function' ? procSub(position[1] || 0) : '');
            config.rows[index].push(typeof procName === 'function'
                ? procName(
                    { value: groupValue, name: transformValue(groupKey, { [groupKey]: groupValue }, structure) },
                    position[1] || 0
                )
                : field.name
            );
        }
        keys.forEach((key: string) => {
            const unit: string = getUnit(key, item, structure);
            const value: any = getValue(key, item, jahr, entity, structure, position);
            config.classes[index].push(classes[2] || 'row_field_vsme_right');
            config.rows[index].push(typeof procValues === 'function' ? procValues(value, unit, key) : value);
        });
    }
}

function transformItem(item: any, entity: string, filter: any): any {
    if (!item.tid) {
        return item;
    }

    if (!CACHE[entity]) {
        CACHE[entity] = {};
    }

    if (!CACHE[entity][item.tid]) {
        const status: any = getCustomFormConfig(entity, item, DATA, null, filter) || {};
        CACHE[entity][item.tid] = { ...item };

        Object.keys(status).forEach((key: string) => {
            if ((status[key].hidden || status[key].hidden_input) && ['jahr', 'standort_tid'].indexOf(key) === -1) {
                delete CACHE[entity][item.tid][key];
            }
        });
    }

    return CACHE[entity][item.tid];
}

function transformValue(key: string, item: any, structure: any): any {
    const atts: any[] = structure.ATTS || [];
    const field: any = atts.find((item: any) => item.KEY === key) || {};
    const opts: any = field.OPTS || null;
    let value: any = item[key];

    if (Array.isArray(opts)) {
        value = (opts.find((opt: any) => opt.VALUE == item[key]) || {}).TITEL || '';
    }

    return value;
}
